import React, { useState } from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import AccountGrid from './AccountGrid';
import AccountSubmenu from './submenu';
const Accounts = () => {

  const [isDetailsTab, setIsDetailsTab] = useState(true);

  return (
    <React.Fragment>
      <div className="page-content p-0">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AccountGrid />
                </CardBody>
              </Card>
              <AccountSubmenu setIsDetailsTab={setIsDetailsTab}/>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Accounts;